import { create } from '@storybook/theming';
import BshLogo from "../assets/img/logo.svg";

export default create({
	base: 'light',
	brandTitle: 'BSH User Guide',
	brandImage: BshLogo,
});
